import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=3dc72932&scoped=true&"
import script from "./RadioItem.vue?vue&type=script&lang=ts&"
export * from "./RadioItem.vue?vue&type=script&lang=ts&"
import style0 from "./RadioItem.vue?vue&type=style&index=0&id=3dc72932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc72932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRadio,VRadioGroup,VRow,VTextField})
